import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filterWorkspace',
})
export class FilterWorkspacePipe implements PipeTransform {
  transform(workspaces: any[], searchText: string = '', count?: boolean, tag_list = []): any[] | number {
    if (count) {
      let counter = 0;
      workspaces.forEach((element) => {
        const { cnt } = element;
        counter = counter + Number(cnt);
        return counter;
      });
      return counter;
    }
    if (!workspaces) {
      return [];
    }

    if (!searchText && tag_list?.length === 0) {
      return workspaces;
    }

    searchText = searchText.toLocaleLowerCase();
    let result = workspaces.filter((workspace) => {
      // 1) workspace name
      if (workspace?.name && workspace?.form_name) return workspace?.form_name?.toLocaleLowerCase().includes(searchText);

      if (
        workspace?.name ? workspace?.name?.toLocaleLowerCase().includes(searchText) : workspace?.form_name?.toLocaleLowerCase().includes(searchText)
      ) {
        return workspace?.name
          ? workspace?.name?.toLocaleLowerCase().includes(searchText)
          : workspace?.form_name?.toLocaleLowerCase().includes(searchText);
      }

      // 2) workspace office clients
      if (workspace.officeWorkspaceClients && workspace?.officeWorkspaceClients[0]?.clientUser) {
        return workspace?.officeWorkspaceClients[0]?.clientUser.name.toLocaleLowerCase().includes(searchText);
      } else if (workspace.officeWorkspaceClients && workspace?.officeWorkspaceClients[0]?.networkClientGroup) {
        return workspace?.officeWorkspaceClients[0]?.networkClientGroup.name.toLocaleLowerCase().includes(searchText);
      }

      // 3) workspace office members
      if (workspace.officeWorkspaceMembers) {
        const result = workspace.officeWorkspaceMembers.filter((member) => {
          if (member.memberUser && !member.workspace_folder_id) {
            return member.memberUser.name.toLocaleLowerCase().includes(searchText);
          } else if (member.networkClientGroup && !member.workspace_folder_id) {
            return member.networkClientGroup.name.toLocaleLowerCase().includes(searchText);
          }
        });

        return result.length > 0 ? true : false;
      }
    });

    if (tag_list.length) {
      result = result.filter((item) => {
        if (item.tag) {
          const tagElement = JSON.parse(item.tag);
          const document_type_list = tagElement.document_type.split(',').map((item) => item.trim());
          let output = false;
          document_type_list.forEach((type) => {
            if (tag_list.includes(type)) {
              output = true;
            }
          });
          if (output) {
            return item;
          }
        }
      });
    }
    return result;
  }
}
